import React from 'react'
import styled from 'styled-components'
import IconControl from './icon-control'
import colours from '../lib/colours'

import '../css/search-widget.css'

const StyledSearchContainer = styled.div`
  position: relative;
  display: flex;
  color: ${colours.darkPurple};
`

const borderRadius = '4px'

const StyledInputPrepend = styled.div`
  align-items: center;
  margin-bottom: 0;
  color: ${colours.mediumPurple};
  text-align: center;
  display: flex;
  float: left;
  font-size: 18px;
  padding-left: 18px;
  padding-right: 18px;
  background: ${colours.white};
  border: 1px solid ${colours.mediumPurple};
  border-radius: ${borderRadius} 0 0 ${borderRadius};
`

const StyledInput = styled.div`
  border: 1px solid ${colours.mediumPurple};
  border-radius: 0 ${borderRadius} ${borderRadius} 0;
  background-color: ${colours.white};
  border-left: 0;
  width: 100% !important;
  height: 50px;
  padding-right: 3px;
`

const SearchControl = () => {
  return (
    <StyledSearchContainer>
      <StyledInputPrepend>
        <IconControl icon="map-marker-alt" />
      </StyledInputPrepend>
      <StyledInput id="mapSearchWidgetInput" />
    </StyledSearchContainer>
  )
}

export default SearchControl
